import React, { useEffect } from 'react'
import { Card, Col, Row, Dropdown, Menu, Skeleton, Tag, Tooltip } from 'antd'
import { IoIosArrowDropdownCircle } from 'react-icons/io'
import { useDispatch } from 'react-redux'
import { useAuthSelector } from 'store/authSlice/authReducer'
import { timeInAgo } from 'utils'
import { GrView } from 'react-icons/gr'
import { useHistory } from 'react-router-dom'
import {
  fundraiserActions,
  useFundraiserSelector,
} from 'store/fundraiserSlice/fundraiserReducer'
import {
  getAllPresenterFundraisers,
  acceptFundraiserInvite,
  rejectFundraiserInvite,
} from 'store/fundraiserSlice/fundraiserActions'

const FundraiserInvites = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const { loading, fundraisers } = useFundraiserSelector()
  const { user } = useAuthSelector()

  useEffect(() => {
    dispatch(getAllPresenterFundraisers(user.email))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onAcceptClick = (recordId) => {
    dispatch(acceptFundraiserInvite(recordId, user.email))
  }

  const onRejectClick = (recordId) => {
    dispatch(rejectFundraiserInvite(recordId, user.email))
  }

  const onViewClick = (recordId) => {
    dispatch(fundraiserActions.setFundraiser(null))
    history.push(`/fundraisers/${recordId}`)
  }

  const customMenu = (recordId, isPending) => (
    <>
      {isPending ? (
        <Menu>
          <Menu.Item
            id="acceptInvite"
            key={1}
            onClick={() => onAcceptClick(recordId)}
          >
            Accept Invitation
          </Menu.Item>
          <Menu.Item
            id="rejectInvite"
            key={2}
            onClick={() => onRejectClick(recordId)}
          >
            Reject Invitation
          </Menu.Item>
        </Menu>
      ) : (
        <></>
      )}
    </>
  )

  const PRESENTER_FUNDRAISERS = fundraisers.filter(
    (record) => record?.acceptanceStatus !== 'Rejected',
  )

  return (
    <Card
      className="header-solid"
      bordered={false}
      title={[
        <>
          <h6 className="mb-0 t-text-2xl">My Invites</h6>
          <h6 className="font-regular">
            You are invited to host the following fundraisers
          </h6>
        </>,
      ]}
    >
      <div style={{ minHeight: 'calc(100vh - 250px)' }}>
        <Skeleton loading={loading} active paragraph={{ rows: 18 }}>
          <Col span={24}>
            {PRESENTER_FUNDRAISERS.length === 0 && (
              <Card className="t-h-96 t-w-full t-flex t-justify-center t-items-center">
                <div>No Invites</div>
              </Card>
            )}
            <div id="presenterEventList">
              {PRESENTER_FUNDRAISERS.map((item, index) => (
                <Card key={index} className="w-full t-my-2 t-p-2">
                  <Row gutter={[24, 0]} className="t-flex t-justify-between">
                    <div className="font-bold t-flex t-space-x-4">
                      <div>
                        Organization{' '}
                        <span className="t-italic t-text-secondary-100">
                          {item?.organizationName}
                        </span>{' '}
                        invited you to present the fundraiser{' '}
                        <span className="t-italic t-text-secondary-100">
                          {item?.title}
                        </span>
                      </div>
                      <div>
                        {item?.acceptanceStatus === 'Accepted' && (
                          <Tag color="green" className="font-bold">
                            Accepted
                          </Tag>
                        )}
                        {item?.acceptanceStatus === 'Rejected' && (
                          <Tag color="red" className="font-bold">
                            Rejected
                          </Tag>
                        )}
                        {(item?.acceptanceStatus === 'Pending' ||
                          !item?.acceptanceStatus) && (
                          <Tag color="gray" className="font-bold">
                            Pending
                          </Tag>
                        )}
                      </div>
                    </div>

                    <Dropdown
                      overlay={customMenu(
                        item?.iD,
                        item?.acceptanceStatus === 'Pending',
                      )}
                    >
                      {item?.acceptanceStatus === 'Pending' ? (
                        <IoIosArrowDropdownCircle
                          id="inviteMenu"
                          fontSize="1.5rem"
                          className="t-text-secondary-100 t-cursor-pointer"
                        />
                      ) : (
                        <>
                          <Tooltip title="View Fundraiser">
                            <GrView
                              id="viewEvent"
                              fontSize="1.2rem"
                              className="t-text-secondary-100 t-cursor-pointer"
                              onClick={() => onViewClick(item.iD)}
                            />
                          </Tooltip>
                        </>
                      )}
                    </Dropdown>
                  </Row>
                  <Row gutter={[24, 0]}>
                    <Tooltip title="Start Date">
                      {item?.startDate && timeInAgo(item.startDate)}
                    </Tooltip>
                  </Row>
                </Card>
              ))}
            </div>
          </Col>
        </Skeleton>
      </div>
    </Card>
  )
}

export { FundraiserInvites }
